export default __webpack_public_path__ + "static/media/hassan2.128841a1.JPG";